export default customElements.define('w-counter', class Counter extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-counter';

        const config = {
            styleSelector,
            templateHTML: `
            <div class="${styleSelector}__container" data-root>
                <w-widget-button label="Decrease value" icon="minus" data-minus></w-widget-button>
                <span class="${styleSelector}__input" data-slot="input" data-slot-required data-input></span>
                <w-widget-button label="Increase value" icon="plus" data-plus></w-widget-button>
            </div>`,
            cacheDom: ['data-minus', 'data-input', 'data-plus']
        };

        super(config);

        this.Direction = Object.freeze({
            Increment: 0,
            Decrement: 1
        });

        this.onConnectedCallback = async () => {
            this.classList.add(this.styleSelector);

            if (!this.dom.input.tagName.includes('W-TEXTBOX')) {
                wealthify.error.throwError(this.tagName, 'Only w-textbox are allowed to be passed into the data-slot currently');
            }

            this.dom.minus.addEventListener('mouseup', () => {
                this._changeValueByStep(this.Direction.Decrement);
            });

            this.dom.plus.addEventListener('mouseup', () => {
                this._changeValueByStep(this.Direction.Increment);
            });

            this.dom.input.addEventListener('valuechange', () => {
                const isNewValue = this.value !== wealthify.type.number.toNumber(this.dom.input.value);

                if (isNewValue) {
                    this.value = this.dom.input.value;
                }
            });

            this.dom.input.addEventListener('validchange', () => {
                this.valid = this.dom.input.valid;
            });
        };
    }

    static get observedProps() {
        return [
            new wealthify.Prop('value', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),
            new wealthify.Prop('min', {type: wealthify.propTypes.Number()}),
            new wealthify.Prop('max', {type: wealthify.propTypes.Number()}),
            new wealthify.Prop('stepsize', {
                default: 1,
                type: wealthify.propTypes.Number()
            })
        ];
    }

    get propCallbacks() {
        return {
            value: () => {
                // only update the input when different to the prop
                const isNewValue = this.dom.input.value === undefined || this.value !== wealthify.type.number.toNumber(this.dom.input.value);

                if (isNewValue) {
                    this.dom.input.value = this.value;
                }

                this.dispatchEvent(new Event('valuechange'));
            },
            min: () => {
                this.dom.input.min = this.min;

                // will update the value to min range if lower than new min value
                this._changeValue(this.value);
            },
            max: () => {
                this.dom.input.max = this.max;

                // will update the value to max range if higher than new max value
                this._changeValue(this.value);
            },
            stepsize: () => {}
        };
    }

    _isValid(value) {
        return this._validateLower(value) && this._validateUpper(value);
    }

    _validateUpper(value) {
        return this.max !== undefined ? value <= this.max : true;
    }

    _validateLower(value) {
        return this.min !== undefined ? value >= this.min : true;
    }

    _changeValueByStep(direction) {
        const result = direction === this.Direction.Increment ? this.value + this.stepsize : this.value - this.stepsize;

        this._changeValue(result);
    }

    _changeValue(value) {
        const lowerRangeValid = this._validateLower(value);
        const upperRangeValid = this._validateUpper(value);

        // within range
        if (lowerRangeValid && upperRangeValid) {
            this.value = value;

        // too low, jump to min
        } else if (!lowerRangeValid) {
            this.value = this.min;

        // too high, cap to max
        } else if (!upperRangeValid) {
            this.value = this.max;
        }
    }
});